import React, { useEffect } from "react";
import Submit from "../HandleSubmit";
import BottomTimers from "./BottomTimers";
import MainTimers from "./MainTimers";

const Timer = ({
    timerSecondsSelected,
    setTimerSecondsSelected,
    quarterSelected,
    setTimersPerQuarter,
    quarterParams,
    totalTimePlayed,
    isLiveTickerStaff,
    TOTAL_TIME_PLAYED,
    setEventDetailsToAdd,
    EVENT_TYPES,
    setIsModalOpen,
    sides,
    goals,
    setGoals,
    setIsEditing,
    setComponentToInsertInModal,
    matchId,
    setMatchStatus,
    matchStatus,
    matchData,
    setMatchData,
    setEndConfirmationModalOpen,
    setEventsToShow,
    formatApiData,
    homePlayers,
    awayPlayers,
}) => {
    return (
        <div>
            <MainTimers
                quarterParams={quarterParams}
                timerSecondsSelected={timerSecondsSelected}
                setTimerSecondsSelected={setTimerSecondsSelected}
                quarterSelected={quarterSelected}
                setTimersPerQuarter={setTimersPerQuarter}
                TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                setEventDetailsToAdd={setEventDetailsToAdd}
                EVENT_TYPES={EVENT_TYPES}
                setIsModalOpen={setIsModalOpen}
                sideSelected={sides["home"]}
                sideNotSelected={sides["away"]}
                sides={sides}
                backgroundColor="#D2E5DB"
                direction="row"
                goals={goals}
                setGoals={setGoals}
                setIsEditing={setIsEditing}
                setComponentToInsertInModal={setComponentToInsertInModal}
                isLiveTickerStaff={isLiveTickerStaff}
                matchId={matchId}
                setMatchStatus={setMatchStatus}
                matchStatus={matchStatus}
                matchData={matchData}
                setMatchData={setMatchData}
                formatApiData={formatApiData}
                setEventsToShow={setEventsToShow}
                homePlayers={homePlayers}
                awayPlayers={awayPlayers}
            />
            <BottomTimers
                quarterParams={quarterParams}
                quarterSelected={quarterSelected}
                totalTimePlayed={totalTimePlayed}
                setTimersPerQuarter={setTimersPerQuarter}
                TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                setEventDetailsToAdd={setEventDetailsToAdd}
                EVENT_TYPES={EVENT_TYPES}
                setIsModalOpen={setIsModalOpen}
                sideSelected={sides["home"]}
                sideNotSelected={sides["away"]}
                sides={sides}
                backgroundColor="#D2E5DB"
                direction="row"
                goals={goals}
                setGoals={setGoals}
                setIsEditing={setIsEditing}
                setComponentToInsertInModal={setComponentToInsertInModal}
                isLiveTickerStaff={isLiveTickerStaff}
                setMatchStatus={setMatchStatus}
                matchId={matchId}
                matchData={matchData}
                setMatchData={setMatchData}
                matchStatus={matchStatus}
                setEndConfirmationModalOpen={setEndConfirmationModalOpen}
                setEventsToShow={setEventsToShow}
            />
        </div>
    );
};

export default Timer;
